/**
 * @namespace BrandApi
 */
import {CANDIDATES_SOURCES} from "../hmodules/talent-pool/constants/talent-pool.constants.js";

window.BrandAPI = new (function () {

    var self = this;
    var _protected = BaseAPI.call(self);

    self.getBrandSchedulerDayParts = function (brandId, params) {
        var deferred = $q.defer();

        if (!brandId) {
            deferred.reject("No brand id");
        } else {
            _protected.request("brands/" + brandId + "/day_parts", "GET", params)
                .then(function (res) {
                    if (res.data && res.data.data && res.data.status_code == 200) {
                        deferred.resolve(res.data.data);
                    }
                    else {
                        deferred.reject(res);
                    }
                }, function (err) {
                    deferred.reject(err);
                });
        }

        return deferred.promise;
    };

    self.createBrandSchedulerDayParts = function (brandId, name, startTime, endTime) {
        var deferred = $q.defer();

        var payLoad = {
            name: name,
            start_time: startTime,
            end_time: endTime
        };

        _protected.request("brands/" + brandId + "/day_parts", "POST", payLoad)
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.editBrandSchedulerDayParts = function (brandId, dayPartId, name, startTime, endTime) {
        var deferred = $q.defer();

        var payLoad = {
            name: name,
            start_time: startTime,
            end_time: endTime
        };

        _protected.request("brands/" + brandId + "/day_parts/" + dayPartId, "PUT", payLoad)
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.removeBrandSchedulerDayParts = function (brandId, dayPartId) {
        var deferred = $q.defer();

        _protected.request("brands/" + brandId + "/day_parts/" + dayPartId, "DELETE")
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getGroupJobs = function (groupId) {
        var deferred = $q.defer();

        _protected.request('groups/' + groupId + '/brand/jobs', 'GET').then(function (data) {

            if (data && data.data && data.data.data && data.data.status_code == 200) {
                deferred.resolve(data.data.data);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getBrandLocales = function (brandId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/locales/settings', 'GET').then(function (data) {

            if (data && data.data && data.data.data && data.data.status_code == 200) {
                deferred.resolve(data.data.data);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getLocations = function (groupId) {
        var deferred = $q.defer();
        var apiUrl = environmentsConfig.get('coreReaderAPIServers');

        _protected.request(apiUrl +'groups/' + groupId + '/brands', 'GET').then(function (data) {

            if (data && data.data && data.data.data && data.status == 200) {
                deferred.resolve(data.data.data);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getEntryBrandSettings = cacheService.cache(function (brandId) {
        var deferred = $q.defer();

        if (!brandId) {
            deferred.reject({err: "This API required a brand id"});
        }

        var apiUrl = environmentsConfig.get('coreReaderAPIServers');

        _protected.request(apiUrl +'teamlive/brands/' + brandId + '/settings', 'GET').then(function (data) {

            if (data && data.data && data.data.data && data.status == 200) {
                deferred.resolve(data.data.data);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    })[0];

    self.validatePayrollExistence = function (brandId, channel) {
        var deferred = $q.defer();
        var apiUrl = environmentsConfig.get('coreReaderAPIServers');

        var params = {
            channel_codes: channel
        };

        _protected.request(apiUrl +'brands/' + brandId + '/payrolls/validate', "POST", params)
            .then(function (data) {
                if (data && data.data && data.data.data && data.status == 200) {
                    deferred.resolve(data.data.data);
                } else {
                    deferred.reject(data);
                }
            })
            .catch(function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };

    self.getUserBrandsByGroupId = function (groupId) {
        var deferred = $q.defer();

        _protected.request('groups/' + groupId + '/user/brands', 'GET').then(function (data) {

            if (data && data.data && data.data.data && data.data.status_code == 200) {
                deferred.resolve(data.data.data);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    /**
     * Get all possible interviewers for a brand
     * @public
     * @type function
     * @memberOf BrandAPI#getBrandInterviewers
     * @param {Number} brandId
     * @param {Boolean} [includeChildren]
     * @return {Object} promise
     */
    self.getBrandInterviewers = function (brandId, includeChildren) {
        var deferred = $q.defer();

        var params = {
            include_children: !!includeChildren
        };

        _protected.request('brands/' + brandId + '/users', 'GET', params)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code === 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getUserBrandsTree = function (asTree, isTeamBrands, include_archived) {
        var params = {};
        params.view_mode = asTree ? 'STRUCTURED' : 'FLAT';
        params.include_archived = !!include_archived;
        if (isTeamBrands) {
            params.filter_services = 'TEAM_SCHEDULING';
        }
        var deferred = $q.defer();
        _protected.request('users/brands', 'GET', params).then(function (data) {
            if (data && data.data && data.data.data && data.data.status_code == 200) {
                deferred.resolve(data.data.data.brands);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getDifferentialPayLockUps = function (brandId, params) {
        var deferred = $q.defer();

        _protected.request('/brands/' + brandId + "/differential_pay/lookups", 'GET', params).then(function (data) {
            if (data && data.data && data.data.data && data.data.status_code == 200) {
                deferred.resolve(data.data.data);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.starBrand = function(brandId){
        var deferred = $q.defer();
        _protected.request('brands/' + brandId + '/employers/favourites', 'POST').then(function (data) {
            if (data && data.data && data.data.status_code == 200) {
                deferred.resolve(data);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.unstarBrand = function(brandId){
        var deferred = $q.defer();
        _protected.request('brands/' + brandId + '/employers/favourites', 'DELETE').then(function (data) {
            if (data && data.data && data.data.status_code == 200) {
                deferred.resolve(data);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getBrandsTree = function (brandId, includeJobs, includeParent, filterByServices, includeJobsCount, includeArchived) {
        var deferred = $q.defer();

        var payload = {
            include_jobs: !!includeJobs,
            include_parent: !!includeParent,
            include_archived: !!includeArchived,
        };

        if(filterByServices){
            payload.filter_by_services = filterByServices;
        }

        if (includeJobsCount) {
            payload.include_jobs_count = !!includeJobsCount;
        }

        _protected.request('/brands/' + brandId + "/tree", 'GET', payload).then(function (data) {

            if (data && data.data && data.data.data && data.data.status_code == 200) {
                deferred.resolve(data.data.data);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getUserFavouriteBrands = function () {
        var deferred = $q.defer();

        var apiUrl = environmentsConfig.get('coreReaderAPIServers');
        var url = apiUrl + 'users/favourite_brands';

        _protected.request(url, 'GET').then(function (data) {

            if (data && data.data && data.data.data) {
                deferred.resolve(data.data.data);
            } else {
                deferred.reject(data);
            }

        }).catch( function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };


    self.getBrandServices = function (brandId) {
        var defer = $q.defer();

        _protected.request("brands/services", "GET", { brand_ids: brandId, include_children: false })
            .then(function (res) {
                if (res && res.data && res.data.status_code === 200) {
                    var brands = res.data.data.brands || [];
                    var services = [];

                    for (var i in brands) {
                        if (brands[i].id === parseInt(brandId)) {
                            for (var j in brands[i].services) {
                                var serviceObj = brands[i].services[j];

                                if (serviceObj.type === 'ACTIVE') {
                                    services.push(serviceObj.code);

                                    if (serviceObj.sub_services) {
                                        for (var k in serviceObj.sub_services) {
                                            services.push([serviceObj.code, serviceObj.sub_services[k].code].join("_"));
                                        }
                                    }
                                }
                            }

                            break;
                        }
                    }

                    defer.resolve({ services: services });
                }
                else {
                    defer.reject(res);
                }

            }, function (err) {
                defer.reject(err);
            });


        return defer.promise;
    };

    self.getBrandServicesAsObjects = function (brandIds) {
        var defer = $q.defer();
        var payload = {
            brand_ids: brandIds,
            include_children: false
        }

        _protected.request("brands/services", "GET", payload)
            .then(function (res) {
                if (res && res.data && res.data.status_code === 200) {
                    var brands = res.data.data.brands || [];
                    var services = {};
                    let brandAccessData = {};

                    for (var i in brandIds) {
                        var brandId = brandIds[i];
                        var brandRes = brands.find(function (brand) {
                            return brand.id === parseInt(brandId);
                        });

                        if (brandRes) {
                            for (var j in brandRes.services) {
                                var serviceObj = brandRes.services[j];

                                services[brandId] = services[brandId] || [];

                                services[brandId].push({
                                    code: serviceObj.code,
                                    type: serviceObj.type
                                });

                                if (serviceObj.sub_services) {
                                    for (var k in serviceObj.sub_services) {
                                        var subServiceCode = [serviceObj.code, serviceObj.sub_services[k].code].join("_");
                                        services[brandId].push({
                                            code: subServiceCode,
                                            type: serviceObj.type
                                        });
                                    }
                                }
                            }

                            brandAccessData[brandId] = {
                                services: services,
                                access_type: brandRes.access_type
                            };
                        }
                    }

                    defer.resolve(brandAccessData);
                }
                else {
                    defer.reject(res);
                }

            }, function (err) {
                defer.reject(err);
            });


        return defer.promise;
    };

    self.getBrandsService = async function(service, brandIds) {
        const payload = {
            brand_ids: brandIds.join(','),
            service_code: service
        };

        try {
            const res = await _protected.request("brands/services/check", "GET", payload);
            if (res?.data?.status_code === 200) {
                return res.data.data?.brand_ids_with_service;
            } else {
                return res.data;

            }
        } catch (err) {
            console.error(err);
        }
    };

    self.getHighestBrandDetails = function (includeProfileImage, returnHighestLevelDetails) {
        let defer = $q.defer();
        let params = {
            include_profile_image: includeProfileImage,
            return_highest_level: returnHighestLevelDetails
        };

        _protected.request("users/entry_mode", "GET", params)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.getBrandRestrictedEmailDomains = function (brandId) {
        var deferred = $q.defer();

        _protected.request('/brands/' + brandId + "/restricted_email_domains", 'GET').then(function (data) {
            if (data && data.data && data.data.data && data.data.status_code == 200) {
                deferred.resolve(data.data.data);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    //Returns a list of available employers (job assignees) for given brand
    self.getJobAssignees = function (brandId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/jobs/assignees', 'GET', {})
            .then(function (result) {
                if(result.data.status_code == 200) {
                    deferred.resolve(result.data.data);
                }
                else {
                    deferred.reject(result.data);
                }
            }, function (err) {
            });

        return deferred.promise;
    };

    self.getGoodFaithEstimateSettings = function (brandId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings/good_faith_estimate', 'GET', {})
            .then(function (result) {
                if(result.data.status_code == 200) {
                    deferred.resolve(result.data.data);
                }
                else {
                    deferred.reject(result.data);
                }
            }, function (err) {
            });

        return deferred.promise;
    };

    self.getBrandJobTitlesWithRestrictedPositions = function (brandId, includeSettings) {
        var deferred = $q.defer();
        var params = {};

        if (includeSettings) {
            params['include_settings'] = true;
        }

        _protected.request('brands/' + brandId + '/job_titles', 'GET', params)
            .then(function (res) {
                if (res && res.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res.data);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getBrandJobTitles = function (brandId, includeSettings, status) {
        var deferred = $q.defer();
        var params = {};

        if (includeSettings) {
            params['include_settings'] = true;
        }

        if (status) {
            params['status'] = status;
        }

        _protected.request('brands/' + brandId + '/settings/job_titles', 'GET', params)
            .then(function (res) {
                if(res && res.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res.data);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.updateBrandJobTitles = function (brandId, jobTitles) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings/job_titles', 'PUT', {job_titles: jobTitles})
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.updateBrandJobTitlesExtraPay = async (brandId, jobTitles) => {
        let payload = {
            payable_job_titles: jobTitles
        }

        const res = await _protected.request(`brands/${brandId}/settings/payable_job_titles`, 'PUT', payload);

        if (res.status === 200 && res.data?.data) {
            return res.data.data;
        } else {
            throw res;
        }
    };

    self.getUserJobApplications = function (fromDate, toDate) {
        var deferred = $q.defer();

        var params = {
            applied_from: moment(fromDate).format("YYYY-MM-DD"),
            applied_to: moment(toDate).format("YYYY-MM-DD")
        };

        _protected.request('users/jobs/applications', 'GET', params)
            .then(function (res) {
                if (res && res.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res.data.data);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getAssignedJobsSettings = function () {
        var deferred = $q.defer();


        _protected.request('assigned_jobs/settings', 'GET', {})
            .then(function (res) {
                if (res && res.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res.data.data);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };


    self.getUserAssignedJobs = function (brandId, userIds, statuses, publishedStart, publishedEnd, usersFilterMode, includeArchived) {
        var deferred = $q.defer();

        var params = {
            statuses: statuses,
            brand_id: brandId,
            users_filter_mode: usersFilterMode
        };

        if (publishedStart) {
            params['publish_start'] = publishedStart;
        }

        if (publishedEnd) {
            params['publish_end'] = publishedEnd;
        }

        if (includeArchived) {
            params['include_archived'] = includeArchived;
        }

        if (userIds) {
            params.user_ids = userIds;
        }

        _protected.request('users/jobs', 'GET', params)
            .then(function (res) {
                if (res && res.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res.data.data);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getUserBrands = function () {
        var deferred = $q.defer();


        _protected.request('users/brands', 'GET', {})
            .then(function (res) {
                if (res && res.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res.data.data);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.hasDistributorPaymentMethod = function (brandId) {
        var defer = $q.defer();

        _protected.request("brands/" + brandId + "/distributor_payment_check", "POST")
            .then(function (res) {
                if (res && res.data && res.data.status_code === 200) {
                    defer.resolve(res.data.data.brand_has_payment_method);
                } else {
                    defer.reject(res);
                }

            }, function (err) {
                defer.reject(err);
            });


        return defer.promise;
    };

    self.clearEnterpriseDataCaches = function (enterprise_id, service_code) {
        _protected.clearCache(enterprise_id + '_' + service_code + '_enterprise_details');
    };

    self.getEnterpriseBrands = function (enterprise_id, service_code) {
        var deferred = $q.defer();
        var requestIdentifier = enterprise_id + '_' + service_code + '_enterprise_details';
        var cached = _protected.getCached(requestIdentifier);

        if (cached) {
            deferred.resolve(cached);
            return deferred.promise;
        }

        _protected.request('brands/' + enterprise_id + "/enterprise_details?service_code=" + service_code, 'GET').then(function (data) {

            if (data && data.data && data.data.data && data.data.status_code == 200) {
                _protected.cache(requestIdentifier, data.data.data.brands);
                deferred.resolve(data.data.data.brands);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getSickLeaveSettings = function (brandId) {
        var deferred = $q.defer();

        _protected.request('/brands/' + brandId + '/settings/sick_leave', 'GET').then(function (data) {

            if (data && data.data && data.data.data && data.data.status_code == 200) {
                deferred.resolve(data.data.data);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.setSickLeaveSettings = function (brandId, payload) {
        var deferred = $q.defer();

        _protected.request('/brands/' + brandId + '/settings/sick_leave', 'PUT', payload).then(function (data) {

            if (data && data.data && data.data.data && data.data.status_code == 200) {
                deferred.resolve(data.data.data);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getCompensationOptions = function (brandId) {
        var deferred = $q.defer();

        _protected.request('/brands/' + brandId + '/compensation_options', 'GET').then(function (res) {

            if (res && res.data && res.data.data && res.data.status_code === 200) {
                deferred.resolve(res.data.data);
            } else {
                deferred.reject(res);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getReportingTimeSettings = function (brandId) {
        var deferred = $q.defer();

        _protected.request('/brands/' + brandId + '/settings/call_in', 'GET').then(function (res) {

            if (res && res.data && res.data.data && res.data.status_code === 200) {
                deferred.resolve(res.data.data);
            } else {
                deferred.reject(res);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.setReportingTimeSettings = function (brandId, payload) {
        var deferred = $q.defer();

        _protected.request('/brands/' + brandId + '/settings/call_in', 'PUT', payload).then(function (res) {

            if (res && res.data && res.data.data && res.data.status_code === 200) {
                deferred.resolve(res.data.data);
            } else {
                deferred.reject(res);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getReportingTimeTypes = function (brandId) {
        var deferred = $q.defer();

        _protected.request('/brands/' + brandId + '/settings/call_in/types', 'GET').then(function (res) {

            if (res && res.data && res.data.data && res.data.status_code === 200) {
                deferred.resolve(res.data.data);
            } else {
                deferred.reject(res);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getCaliforniaSplitShiftPremiumSettings = function (brandId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings/split_shift_penalty', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.updateCaliforniaSplitShiftPremiumSettings = function (brandId, payload) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings/split_shift_penalty', 'PUT', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.isEnterpriseBrand = function (brand_id) {
        var deferred = $q.defer();

        _protected.request('brands/' + brand_id + "/check_enterprise", 'GET').then(function (data) {

            if (data && data.data && data.data.data && data.data.status_code == 200) {
                deferred.resolve(data.data.data.is_enterprise);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.facebookPageFeeds = function (page_name, limit) {
        var deferred = $q.defer();

        var data = {
            page_name: page_name,
            limit: limit
        };

        _protected.request("facebook_page_feeds", 'GET', data)
            .then(function (data) {

                if (data && data.data && data.data.data && data.data.status_code == 200) {
                    deferred.resolve(data.data.data);
                } else {
                    deferred.reject(data);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.twitterPageFeeds = function (page_name, limit) {
        var deferred = $q.defer();

        var data = {
            page_name: page_name,
            limit: limit
        };

        _protected.request("twitter_page_feeds", 'GET', data)
            .then(function (data) {

                if (data && data.data && data.data.data && data.data.status_code == 200) {
                    deferred.resolve(data.data.data);
                } else {
                    deferred.reject(data);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    //Add brand location
    self.saveBrandLocation = function (payload) {
        var deferred = $q.defer();

        _protected.request("brand/location", 'PUT', payload)
            .then(function (data) {

                if (data && data.data && data.data.data && data.data.status_code == 200) {
                    deferred.resolve(data.data.data);
                } else {
                    deferred.reject(data);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getBrandPublicLocations = function (brandId) {
        var deferred = $q.defer();

        _protected.request("brand_locations/" + brandId, 'GET')
            .then(function (data) {

                if (data && data.data && data.data.data && data.data.status_code == 200) {
                    deferred.resolve(data.data.data);
                } else {
                    deferred.reject(data);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getBrandLocations = function (brandId) {
        var deferred = $q.defer();

        if (!brandId) {
            deferred.reject({err: "Please send brand id"});
        } else {
            _protected.request("brand/location/" + brandId, 'GET')
                .then(function (data) {

                    if (data && data.data && data.data.data && data.data.status_code == 200) {
                        deferred.resolve(data.data.data);
                    } else {
                        deferred.reject(data);
                    }

                }, function (err) {
                    deferred.reject(err);
                });
        }

        return deferred.promise;
    };

    //Media
    self.getLocations = function (groupId) {
        var deferred = $q.defer();
        var apiUrl = environmentsConfig.get('coreReaderAPIServers');

        _protected.request(apiUrl +'groups/' + groupId + '/brands', 'GET').then(function (data) {

            if (data && data.data && data.data.data && data.status == 200) {
                deferred.resolve(data.data.data);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };
    self.getImagePreSignedUrl = async (brandId, fileExtension) => {
        try {
            let payload = {
                file_extension: fileExtension
            };

            const res = await _protected.request(`brands/${brandId}/notification_center/presigned_url`, 'GET', payload);
            if (res?.data) {
                return res.data.data;
            } else {
                throw new Error('Failed to get pre-signed URL');
            }
        } catch (err) {
            throw new Error(err.message || 'Error fetching pre-signed URL');
        }
    };


    /* get Brand business day */
    self.getBrandBusinessDay = function (brandId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings/business_day', 'GET').then(function (data) {

            if (data && data.data && data.data.data && data.data.status_code == 200) {
                deferred.resolve(data.data.data);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    /* update Brand business day */
    self.updateBrandBusinessDay = function (brandId, payload) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings/business_day', 'PUT', payload).then(function (data) {

            if (data && data.data && data.data.data && data.data.status_code == 200) {
                deferred.resolve(data.data.data);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    /* get brand overtime settings */
    self.getBrandOvertimeSettings = function (brandId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings/overtime', 'GET').then(function (data) {

            if (data && data.data && data.data.data && data.data.status_code == 200) {
                deferred.resolve(data.data.data);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getBrandRestDaySettings = function (brandId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings/restday_pay', 'GET')
            .then(function (result) {
                if (result && result.data && result.data.data && result.data.status_code == 200) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getBrandAbsenceOvertimeSettings = function (brandId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings/absences/overtime', 'GET')
            .then(function (result) {
                if (result && result.data && result.data.data && result.data.status_code == 200) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.updateBrandAbsenceOvertimeSettings = function (brandId, payload) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings/absences/overtime', 'PUT', payload)
            .then(function (result) {
                if (result && result.data && result.data.data && result.data.status_code == 200) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getUKBrandPayTypesOvertimeSettings = function (brandId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings/pay_types/overtime', 'GET').then(function (data) {

            if (data && data.data && data.data.data && data.data.status_code == 200) {
                deferred.resolve(data.data.data);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    /* update brand overtime settings */
    self.updateBrandOvertimeSettings = function (brandId, payload) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings/overtime', 'PUT', payload).then(function (data) {

            if (data && data.data && data.data.data && data.data.status_code == 200) {
                deferred.resolve(data.data.data);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.updateBrandRestDaySettings = function (brandId, payload) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings/restday_pay', 'PUT', payload)
            .then(function (result) {
                if (result && result.data && result.data.data && result.data.status_code == 200) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.updateUKBrandPayTypesOvertimeSettings = function (brandId, payload) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings/pay_types/overtime', 'PUT', payload).then(function (data) {

            if (data && data.data && data.data.data && data.data.status_code == 200) {
                deferred.resolve(data.data.data);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    /**
     * get brand minimum wage settings
     * @param brandId
     */
    self.getBrandMinimumWageSettings = function (brandId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/settings/minimum_wages', 'GET')
            .then(function (data) {
                if (data && data.data && data.data.data && data.data.status_code == 200) {
                    deferred.resolve(data.data.data);
                } else {
                    deferred.reject(data);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.updateBrandMinimumWageRule = function (brandId, ruleData, ruleId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        } else if (!ruleData) {
            throw "Please send the updated rule";
        } else if (!ruleId) {
            throw "Please send the rule id.";
        }

        _protected.request('brands/' + brandId + '/settings/minimum_wages/' + ruleId, 'PUT', ruleData)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.addBrandMinimumWageRule = function (brandId, ruleData) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        } else if (!ruleData) {
            throw "Please send the new rule.";
        }

        _protected.request('brands/' + brandId + '/settings/minimum_wages' , 'POST', ruleData)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.deleteBrandMinimumWageRule = function (brandId, ruleId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }  else if (!ruleId) {
            throw "Please send the rule id.";
        }

        _protected.request('brands/' + brandId + '/settings/minimum_wages/' + ruleId, 'DELETE')
            .then(function (res) {

                if (res && res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /* brand login settings */
    self.getBrandLoginTypesSettings = function (brandId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings/login_types', 'GET').then(function (data) {

            if (data && data.data && data.data.data && data.data.status_code == 200) {
                deferred.resolve(data.data.data);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };


    self.updateBrandLoginTypesSettings = function (brandId, payload) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings/login_types', 'PUT', payload).then(function (data) {

            if (data && data.data && data.data.data && data.data.status_code == 200) {
                deferred.resolve(data.data.data);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    /* Set Sheets time format settings */
    self.updateSheetsTimeFormatSettings = function (brandId, payload) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings/sheet_time_format', 'PUT', payload).then(function (data) {

            if (data && data.data && data.data.data && data.data.status_code == 200) {
                deferred.resolve(data.data.data);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    //Save brand basic settings
    self.updateBrandBasicInformation = function (payload) {
        var deferred = $q.defer();

        _protected.request('brand/basic_information', 'POST', payload).then(function (data) {

            if (data && data.data && data.data.data && data.data.status_code == 200) {
                deferred.resolve(data.data.data);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.updateEmployeeNameSettings = function (brandId, payload) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/brand_user_name_display_settings', 'PUT', payload)
            .then(function (data) {

                if (data && data.data && data.data.data && data.data.status_code == 200) {
                    deferred.resolve(data.data.data);
                } else {
                    deferred.reject(data);
                }

            }).catch(function (error) {
            deferred.reject(error);
        });

        return deferred.promise;
    };

    self.getEmployeeNameSettings = function (brandId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/brand_user_name_display_settings', 'GET')
            .then(function (data) {

                if (data && data.data && data.data.data && data.data.status_code == 200) {
                    deferred.resolve(data.data.data);
                } else {
                    deferred.reject(data);
                }

            }).catch(function (error) {
            deferred.reject(error);
        });

        return deferred.promise;
    };

    //H-MAP API changes / Add user to GP
    self.addUserToGP = function (groupId, payload) {
        var deferred = $q.defer();

        _protected.request('brands/' + groupId + '/users/permissions', 'POST', payload).then(function (res) {
            if (res && res.data && res.data.status_code === 200) {
                deferred.resolve(res.data.data);
            } else {
                deferred.reject(res);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.editUserAccessBrands = function (brandId, userId, payload) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/users/' + userId + '/permissions', 'PUT', payload).then(function (res) {
            if (res && res.data && res.data.status_code === 200) {
                deferred.resolve(res.data.data);
            } else {
                deferred.reject(res);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getUserDetails = function (brandId, userId) {

        var deferred = $q.defer();
        var params = {};

        _protected.request('brands/' + brandId + '/users/' + userId + '/permissions' , 'GET', params)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code === 200) {
                    deferred.resolve(res.data.data.user);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    //H-MAP API changes / Get users and permission under GP
    self.getGPUsersPermissions = function (groupId) {
        var deferred = $q.defer();

        _protected.request('brands/' + groupId + '/users/permissions', 'GET').then(function (res) {

            if (res && res.data && res.data.data && res.data.status_code == 200) {
                deferred.resolve(res.data.data);
            } else {
                deferred.reject(res);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    //H-MAP API changes / Get users and permission under GP
    self.deleteUserFromGP = function (groupId, userId) {
        var deferred = $q.defer();

        _protected.request('brands/'+groupId+'/users/'+userId+'/permissions', 'DELETE').then(function (res) {

            if (res && res.data && res.data.data && res.data.status_code == 200) {
                deferred.resolve(res.data.data);
            } else {
                deferred.reject(res);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.updateGPUserPermissions = function (groupId, userId, payload) {
        var deferred = $q.defer();

        _protected.request('brands/' + groupId + '/users/' + userId + '/permissions', 'PUT', payload).then(function (res) {

            if (res && res.data && res.data.data && res.data.status_code == 200) {
                deferred.resolve(res.data.data);
            } else {
                deferred.reject(res);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getBrandRevenueCenters = function (brandId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        } else {
            _protected.request("brands/" + brandId + "/revenue_centers", "GET")
                .then(function (res) {
                    if (res.data && res.data.data && res.data.data.revenue_centers && res.data.status_code == 200) {
                        deferred.resolve(res.data.data.revenue_centers);
                    }
                    else {
                        deferred.reject(res);
                    }
                }, function (err) {
                    deferred.reject(err);
                });
        }

        return deferred.promise;
    };

    self.editOrCreateBrandRevenueCenters = function (brandId, revenue_centers) {
        var deferred = $q.defer();

        if (!Array.isArray(revenue_centers) || !revenue_centers) {

            var revenueCenterSample = [
                {
                    "id": 50,
                    "name": "Revenue Center One",
                    "icon": "fa-umbrella"
                },
                {
                    "name": "Revenue Center I",
                    "icon": "fa-car"
                }
            ];

            throw "Please send revenue centers to edit as array of revenue centers for example: revenue_centers:" + JSON.stringify(revenueCenterSample);
        }

        var payLoad = {
            revenue_centers: revenue_centers
        };

        _protected.request("brands/" + brandId + "/revenue_centers", "PUT", payLoad)
            .then(function (res) {
                if (res.data && res.data.data && res.data.data.revenue_centers && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };
    self.getBrandCostCenter = function (brandId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/cost_centers', 'GET').then(function (res) {

            if (res && res.data && res.data.data && res.data.data.cost_centers && res.data.status_code == 200) {
                deferred.resolve(res.data.data.cost_centers);
            } else {
                deferred.reject(res);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.editOrCreateBrandCostCenter = function (brandId, costCenters) {
        var deferred = $q.defer();

        if (!costCenters) {
            var expectedRequest = {
                "cost_centers": [{
                    "id": 123,
                    "code": "CC2",
                    "name": "Departmentz",
                    "values": [
                        {
                            "_comment_1": "id is required if it already exists and you are updating, if not provided we will create new one",
                            "id": 56,
                            "code": "ENG",
                            "name": "Engineering"
                        },
                        {
                            "id": 57,
                            "code": "Prod",
                            "name": "Porduct"
                        }
                    ]
                }]
            };

            throw 'Please send a cost center as expected value as this' + JSON.stringify(expectedRequest);
        }

        var request = {};
        request['cost_centers'] = costCenters;

        _protected.request('brands/' + brandId + '/cost_centers', 'PUT', request).then(function (res) {

            if (res && res.data && res.data.data && res.data.data.cost_centers && res.data.status_code == 200) {
                deferred.resolve(res.data.data.cost_centers);
            } else {
                deferred.reject(res);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getHARAFRestrictions = function (brandId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/haraf_restrictions', 'GET')
            .then(function (res) {

                if (res && res.status === 200 && res.data) {
                    deferred.resolve(res.data.data && res.data.data.categories);
                }
                else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };


    self.setLifeTimeSettings = function (brandId, jobId, minLifeTime, maxLifeTime) {
        var deferred = $q.defer();

        var payLoad = {};
        payLoad['min_life_time'] = parseInt(minLifeTime);
        payLoad['max_life_time'] = parseInt(maxLifeTime);

        _protected.request('brands/' + brandId + '/jobs/' + jobId + '/settings/life_time', 'PUT', payLoad)
            .then(function (res) {

                if (res && res.status === 200 && res.data && res.data.data) {
                    deferred.resolve(res.data.data.brands);
                }
                else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /**
     * @name BrandApi#getBrandSkipReasons
     * @param brandId
     */
    self.getBrandSkipReasons = function (brandId, filterBy) {
        if (!brandId) {
            throw new Error('Brand id is required entity', Date.now());
        }

        var deferred = $q.defer();
        filterBy = filterBy || 'ALL';

        _protected.request('brands/' + brandId + '/skip_reasons?filter_by=' + filterBy, 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                if (err.status === 422) {
                    deferred.reject({error: {code: 'NO_SKIP_REASON'}});
                } else if (err.status === 403) {
                    deferred.reject({error: {code: 'SERVICE_DISABLED'}});
                } else {
                    deferred.reject(err);
                }
            });

        return deferred.promise;
    };

    /**
     * @name BrandApi#editOrCreateOrDeleteSkipReasons
     * @param brandId
     * @param reasons
     * @param isUsageRequired
     */
    self.editOrCreateOrDeleteSkipReasons = function (brandId, reasons, isUsageRequired) {
        if (!reasons || !Array.isArray(reasons)) {
            var requestExample = {
                "reasons": [
                    {
                        "id": 39,
                        "is_all_swimlanes": false,
                        "reason": "aaaa-510064",
                        "swimlane_ids": [
                            2,
                            3,
                            4
                        ]
                    },
                    {
                        "id": 40,
                        "is_all_swimlanes": false,
                        "reason": "bbbbc-510064",
                        "swimlane_ids": [
                            2
                        ]
                    },
                    {
                        "id": 41,
                        "is_all_swimlanes": true,
                        "reason": "ccccc-510064"
                    }
                ]
            };

            throw new Error('Reasons is a required entity' + JSON.stringify(requestExample), Date.now());
        }

        if (!brandId) {
            throw new Error('Brand id is required entity', Date.now());
        }

        var payload = {};
        payload['reasons'] = reasons;
        payload['is_usage_required'] = !!isUsageRequired;

        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/skip_reasons', 'PUT', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                if (err.status === 422) {
                    deferred.reject({error: {code: 'NO_SKIP_REASON'}});
                } else if (err.status === 403) {
                    deferred.reject({error: {code: 'SERVICE_DISABLED'}});
                } else {
                    deferred.reject(err);
                }
            });

        return deferred.promise;
    };

    self.addSkipReasonToApplicants = function (brandId, jobId, applicationIds, reasonId) {
        var requestExample = {
            "application_ids": [
                986494,
                986653
            ],
            "skip_reason_id": 3
        };

        if (!applicationIds || !Array.isArray(applicationIds)) {
            throw new Error('application ids is a required entity' + JSON.stringify(requestExample), Date.now());
        }

        if (!reasonId) {
            throw new Error('Reason id is a required entity' + JSON.stringify(requestExample), Date.now());
        }

        if (!brandId) {
            throw new Error('Brand id is required entity', Date.now());
        }

        if (!jobId) {
            throw new Error('Job id is required entity', Date.now());
        }

        var payload = {};
        payload['application_ids'] = applicationIds;
        payload['skip_reason_id'] = reasonId;

        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/jobs/' + jobId + '/applications/skip_reasons', 'POST', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                if (err.status === 422) {
                    deferred.reject({error: {code: 'NO_SKIP_REASON'}});
                } else if (err.status === 403) {
                    deferred.reject({error: {code: 'SERVICE_DISABLED'}});
                } else {
                    deferred.reject(err);
                }
            });

        return deferred.promise;
    };

    self.editSkipReasonToApplicants = function (brandId, jobId, applicationId, reasonId) {
        if (!applicationId) {
            throw new Error('application id is a required entity', Date.now());
        }

        if (!reasonId) {
            throw new Error('Reason id is a required entity', Date.now());
        }

        if (!brandId) {
            throw new Error('Brand id is required entity', Date.now());
        }

        if (!jobId) {
            throw new Error('Job id is required entity', Date.now());
        }

        var payload = {};
        payload['skip_reason_id'] = reasonId;

        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/jobs/' + jobId + '/applications/' + applicationId + '/skip_reasons', 'PUT', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                if (err.status === 422) {
                    deferred.reject({error: {code: 'NO_SKIP_REASON'}});
                } else if (err.status === 403) {
                    deferred.reject({error: {code: 'SERVICE_DISABLED'}});
                } else {
                    deferred.reject(err);
                }
            });

        return deferred.promise;
    };

    self.deleteSkipReasonToApplicants = function (brandId, jobId, applicationId, reasonId) {
        if (!applicationId) {
            throw new Error('application id is a required entity', Date.now());
        }

        if (!reasonId) {
            throw new Error('Reason id is a required entity', Date.now());
        }

        if (!brandId) {
            throw new Error('Brand id is required entity', Date.now());
        }

        if (!jobId) {
            throw new Error('Job id is required entity', Date.now());
        }

        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/jobs/' + jobId + '/applications/' + applicationId + '/skip_reasons/' + reasonId, 'DELETE')
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                if (err.status === 422) {
                    deferred.reject({error: {code: 'NO_SKIP_REASON'}});
                } else if (err.status === 403) {
                    deferred.reject({error: {code: 'SERVICE_DISABLED'}});
                } else {
                    deferred.reject(err);
                }
            });

        return deferred.promise;
    };

    self.getBrandJobTemplates = function (brandId, excludeParentTemplates, includeInactivePositions, includeChildren, atrPositionCode) {
        var deferred = $q.defer();

        if (!brandId) {
            throw new Error('This API required a brand id', Date.now());
        }

        var payLoad = {};
        payLoad['exclude_parent_templates'] = !!excludeParentTemplates;
        payLoad['include_inactive_positions'] = !!includeInactivePositions;
        payLoad['include_children'] = !!includeChildren;
        if (!_.isEmpty(atrPositionCode)) {
            payLoad['position_code'] = atrPositionCode;
        }

        _protected.request('brands/' + brandId + '/jobs/templates', 'GET', payLoad)
            .then(function (res) {

                if (res?.data?.status_code === 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }

            }, function (err) {
                if (err.status === 403) {
                    deferred.reject({
                        error: 'NOT_AUTHORIZED',
                        status: 403
                    })
                } else {
                    deferred.reject(err);
                }
            });

        return deferred.promise;
    };

    var userBrandsListCache = {};

    self.userBrandsByGroupId = function(groupId, includeServices, includePermissions) {

        var defer = $q.defer();
        var apiUrl = environmentsConfig.get('coreReaderAPIServers');
        var url = apiUrl + 'groups/' + groupId + '/brands';

        if(includeServices && !includePermissions) {
            url += '?include_services=true';
        }

        if(includePermissions && !includeServices) {
            url += '?include_permissions=true';
        }

        if (includeServices && includePermissions) {
            url += '?include_services=true&include_permissions=true';
        }

        if (userBrandsListCache[groupId] && Array.isArray(userBrandsListCache[groupId])) {
            defer.resolve(angular.copy(userBrandsListCache[groupId]));
        } else {
            _protected.request(url, 'GET')
                .then(function (res) {
                    if (res && res.data && res.status === 200) {
                        userBrandsListCache[groupId] = res.data.data;
                        defer.resolve(angular.copy(userBrandsListCache[groupId]));
                    }
                    else {
                        defer.reject(res);
                    }
                }, function (err) {
                    defer.reject(err);
                });
        }

        return defer.promise;
    };

    self.getTemplateBrands = function (brandId, jobTemplateId) {

        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/jobs/' + jobTemplateId + '/templates/brands', 'GET')
            .then(function (res) {

                if (res && res.status === 200 && res.data && res.data.data) {
                    var brands = [];

                    for (var i in res.data.data.brands) {
                        // Root brand is implicitly always selected, remove it from selected brands
                        if (res.data.data.brands[i].id != brandId) {
                            brands.push(res.data.data.brands[i]);
                        }
                    }

                    deferred.resolve(brands);
                }
                else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.setLifeTimeSettings = function (brandId, jobId, minLifeTime, maxLifeTime) {
        var deferred = $q.defer();

        var payLoad = {};
        payLoad['min_life_time'] = parseInt(minLifeTime);
        payLoad['max_life_time'] = parseInt(maxLifeTime);

        _protected.request('brands/' + brandId + '/jobs/' + jobId + '/settings/life_time', 'PUT', payLoad)
            .then(function (res) {

                if (res && res.status === 200 && res.data && res.data.data) {
                    deferred.resolve(res.data.data.brands);
                }
                else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    // parameter filter = OWNED,ALL
    // filter=OWNED to get Rejection templates to manage in the settings
    // Filter = ALL to get Rejection templates to Used eg. in AMS and MyDocs
    self.getBrandRejectionTemplates = function (brandId, filter) {
        if (!brandId) {
            throw new Error('Brand id is required entity for this api', Date.now());
        }
        if (!filter) {
            throw new Error('Fitler is required entity for this api', Date.now());
        }

        var deferred = $q.defer();

        var payLoad = {};
        payLoad['category'] = 'REJECTION';
        payLoad['filter_by'] = filter;

        _protected.request('brands/' + brandId + '/message_templates', 'GET', payLoad)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getSystemRejectionTemplates = function () {
        var deferred = $q.defer();

        var payLoad = {};
        payLoad['category'] = 'REJECTION';
        payLoad['type'] = 'SYSTEM';

        _protected.request('message_templates', 'GET', payLoad)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getSystemInviteToApplyTemplates = function () {
        var deferred = $q.defer();

        var payLoad = {};
        payLoad['category'] = 'INVITE_TO_APPLY';
        payLoad['type'] = 'SYSTEM';

        _protected.request('message_templates', 'GET', payLoad)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.deleteBrandRejectionTemplate = function (brandId, templateId) {
        if (!brandId) {
            throw new Error('Brand id is required entity for this api', Date.now());
        }

        if (!templateId) {
            throw new Error('Template id is required entity for this api', Date.now());
        }

        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/message_templates/' + templateId, 'DELETE')
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };


    self.getRejectionTemplatePoolId = function (brandId) {
        if (!brandId) {
            throw new Error('Brand id is required entity for this api', Date.now());
        }

        var deferred = $q.defer();

        var payLoad = {};

        _protected.request('brands/' + brandId + '/services/REJECTION_TEMPLATE/meta', 'GET', payLoad)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getTemplateSmartFields = function (category) {
        var deferred = $q.defer();

        var payLoad = {};
        payLoad['category'] = category;

        _protected.request('templates/meta', 'GET', payLoad)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getTemplateSharedBrands = function(brandId, templateId){
        if (!brandId) {
            throw 'brandId is required';
        }

        if (!templateId) {
            throw 'templateId is required';
        }

        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/message_templates/' + templateId + '/shared_brands', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.data.brands && res.data.status_code == 200) {
                    deferred.resolve(res.data.data.brands);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    }

    self.getBrandMainJobsSettings = function (brandId, jobId) {

        if (!brandId) {
            throw 'Brand id is required';
        }

        var deferred = $q.defer();

        if (jobId) {
            JobAPI
                .getJobSettingsSection(brandId, jobId)
                .then(function (resJob) {
                    var response = {
                        job_hiring_settings: resJob
                    };

                    _protected.request('brands/' + brandId + '/jobs/settings', 'GET')
                        .then(function (res) {
                            if (res && res.data && res.data.data && res.data.status_code == 200) {
                                response['logjam_settings'] = res.data.data.logjam_settings || {};
                                response['private_job_settings'] = res.data.data.private_job_settings || {};
                                response['weekly_work_time_enabled'] = res.data.data.weekly_work_time_enabled || false;
                                response['apprenticeship_type'] = res.data.data.apprenticeship_type || {};
                                deferred.resolve(response);
                            }
                            else {
                                deferred.reject(res);
                            }
                        }, function (err) {
                            deferred.reject(err);
                        });
                }, function (err) {
                    deferred.reject(err);
                });
        } else {
            _protected.request('brands/' + brandId + '/jobs/settings', 'GET')
                .then(function (res) {
                    if (res && res.data && res.data.data && res.data.status_code == 200) {
                        var response = {
                            logjam_settings: res.data.data.logjam_settings || {},
                            private_job_settings: res.data.data.private_job_settings || {},
                            employment_type_enabled: res.data.data.employment_type_enabled || false,
                            weekly_work_time_enabled : res.data.data.weekly_work_time_enabled || false,
                            apprenticeship_type: res.data.data.apprenticeship_type || {},
                        };

                        deferred.resolve(response);
                    }
                    else {
                        deferred.reject(res);
                    }
                }, function (err) {
                    deferred.reject(err);
                });
        }

        return deferred.promise;
    };


    /** GET brands tree under GP
     * @param base_brand_id
     */
    self.getFlattedBrandsTree = function (brandId, types, offset, limit, flow, name) {
        var deferred = $q.defer();

        var params = {
            brand_id: brandId,
            types: types,
            offset: offset,
            limit: limit,
            flow: flow
        };

        if (name) {
            params.name = name;
        }

        _protected.request("brand_flat_tree", "GET", params)
            .then(function (res) {
                    if (res.data && res.data.data && res.data.status_code == 200) {
                        deferred.resolve(res.data.data);
                    }
                    else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    console.error(err);
                    deferred.reject(err);
                });

        return deferred.promise;
    };


    self.getFlattedBrandsTreeSearch = function (brandId, types, services, offset, limit, filterByName) {
        var deferred = $q.defer();

        var params = {
            types: types,
            offset: offset || 0,
            limit: limit || 100
        };

        if (filterByName) {
            params['name'] = filterByName;
        }

        if (services && Array.isArray(services) && services.length) {
            params['filter_by_services'] = services;
        }

        _protected.request("brands/" + brandId + "/flat_tree", "GET", params)
            .then(function (res) {
                    if (res.data && res.data.data && res.data.data.brands && res.data.status_code == 200) {
                        deferred.resolve(res.data.data.brands);
                    }
                    else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    console.error(err);
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    self.getBrandsFlatTreeNavigation = function (brandId, types, filterByService, name, offset, limit) {

        var deferred = $q.defer();

        var params = {
            offset: offset,
            limit: limit,
            name: name,
            filter_by_service: filterByService,
            types: types
        };

        _protected.request("brands/" + brandId + '/flat_tree', "GET", params)
            .then(function (res) {
                    if (res.data && res.data.data && res.data.status_code == 200) {
                        deferred.resolve(res.data.data.brands || []);
                    }
                    else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    self.getBrandsCities = function (brandId) {
        var deferred = $q.defer();

        var params = {};

        _protected.request("brand_cities?brand_id=" + brandId, "GET", params)
            .then(function (res) {
                    if (res.data && res.data.data && res.status == 200) {
                        deferred.resolve(_.sortBy(res.data.data.cities, 'name'));
                    }
                    else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    console.error(err);
                    deferred.reject(err);
                });

        return deferred.promise;
    };
    self.getBrandsFinancialUnits = function (brandId, params) {
        var deferred = $q.defer();

        _protected.request("brands/" + brandId + '/financial_units/brands', "GET", params)
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data.brands);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.updateBrandTimeIntervalSettings = function (brandId, timeInterval) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/settings/time_interval', 'PUT', timeInterval)
            .then(function (res) {

                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);

                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getBrandGDPRDisclaimers = function (brandId) {
        var deferred = $q.defer();

        var params = {
            brand_id: brandId
            // types: ['LOGIN', 'JOB_POST']
        };

        _protected.request("brand_disclaimers", "GET", params)
            .then(function (res) {
                if (res.data && res.data.data && res.status == 200) {
                    var disclaimers = res.data.data.disclaimers || [];
                    var result = {};

                    for (var i in disclaimers) {
                        result[disclaimers[i].type] = disclaimers[i];
                    }

                    deferred.resolve(result);
                }
                else {
                    deferred.reject(res);
                }
            },
            function (err) {
                console.error(err);
                deferred.reject(err);
            });

        return deferred.promise;
    };


    self.getBonusSettings = function (brandId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/settings/bonus', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.deleteBonusSettings = function (brandId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/settings/bonus', 'DELETE')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.saveBonusSettings = function (brandId, bonusSettings) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!bonusSettings) {
            throw "No bonus data attached";
        }

        _protected.request('brands/' + brandId + '/settings/bonus', 'PUT' , bonusSettings)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };


    self.getSalariedBrandSettings = function (brandId) {
        var deferred = $q.defer();

        _protected.request("brands/" + brandId + "/settings/salaried", "GET")
            .then(function (res) {
                    if (res.data && res.data.data && res.status == 200) {
                        deferred.resolve(res.data.data);
                    }
                    else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    console.error(err);
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    self.updateSalariedBrandSettings = function (brandId, payload) {
        var deferred = $q.defer();

        _protected.request("brands/" + brandId + "/settings/salaried", "PUT", payload)
            .then(function (res) {
                    if (res.data && res.data.data && res.status == 200) {
                        deferred.resolve(res.data.data);
                    }
                    else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    console.error(err);
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    self.getBrandAdmins = function (brandId) {
        var deferred = $q.defer();

        _protected.request("brands/" + brandId + "/users", "GET")
            .then(function (res) {
                    if (res.data && res.data.data && res.status == 200) {
                        deferred.resolve(res.data.data.users);
                    }
                    else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    console.error(err);
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    self.getBrandsAssignedJobsAdmins = function (jobIds) {

        var deferred = $q.defer();

        var params = {
            job_ids: jobIds
        };

        _protected.request("brands/assigned_jobs/users", "GET", params)
            .then(function (res) {
                    if (res.data && res.data.data && res.status == 200) {
                        deferred.resolve(res.data.data.users);
                    } else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    console.error(err);
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    self.editJobsAssignees = function (jobIds, removedAssignees, addedAssignees) {
        var deferred = $q.defer();

        var payLoad = {
            job_ids: jobIds,
            removed_assignees: removedAssignees,
            added_assignees: addedAssignees
        };

        _protected.request("brands/jobs/assignees", "PUT", payLoad)
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };
    self.deleteJobsAssignees = function (jobIds) {
        var deferred = $q.defer();

        var payLoad = {
            job_ids: jobIds
        };

        _protected.request("brands/jobs/assignees", "DELETE", payLoad)
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.sendInviteToInterview = async (brandId, payload) => {
        const url = `brands/${brandId}/invite_to_interview`;

        try {
            const res = await _protected.request(url, 'POST', payload);

            if (res.status === 200 && res.data?.data) {
                return res.data.data;
            } else {
                throw res;
            }
        } catch (err) {
            throw err;
        }
    }

    self.getBrandMessageTemplates = function (brandId, filter, category, includeSystem) {

        var deferred = $q.defer();

        var payLoad = {};
        payLoad['category'] = category;
        payLoad['filter_by'] = filter;
        payLoad['include_system'] = includeSystem;

        _protected.request('brands/' + brandId + '/message_templates', 'GET', payLoad)
            .then(function (res) {
                if (res && res.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getBulkBrandsMessageTemplates = function (brandsIds, filter, category, includeSystem) {
        let deferred = $q.defer();
        let apiUrl = environmentsConfig.get('coreReaderAPIServers');

        let payload = {
            'brands_ids': brandsIds,
            'category': category,
            'filter_by':filter,
            'include_system': includeSystem
        };

        _protected.request(apiUrl + 'message_templates', 'POST', payload)
            .then(function (res) {
                if (res.status === 200 && res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getMessageTemplatePoolId = cacheService.cache(function (brandId, category) {
        if (!brandId) {
            throw new Error('Brand id is required entity for this api', Date.now());
        }

        var deferred = $q.defer();

        var payLoad = {};

        _protected.request('brands/' + brandId + '/services/' + category + '/meta', 'GET', payLoad)
            .then(function (res) {
                if (res && res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    })[0];

    self.deleteBrandMessageTemplate = function (brandId, templateId) {
        if (!brandId) {
            throw new Error('Brand id is required entity for this api', Date.now());
        }

        if (!templateId) {
            throw new Error('Template id is required entity for this api', Date.now());
        }

        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/message_templates/' + templateId, 'DELETE')
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code === 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getBrandJobsApplicationSources = function(brandId, jobId){
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/jobs/' + jobId + '/applications/sources', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code === 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.sendJobApplyInvitation = async (jobId, candidateIds, subject, message, brandId, source) => {
        var deferred = $q.defer();

        var params = {
            job_id: jobId,
            candidate_id: candidateIds,
            subject: subject,
            message: message,
        };

        if (source === CANDIDATES_SOURCES.SMART_MATCH) {
            params.utm_source = CANDIDATES_SOURCES.SMART_MATCH;
        }

        _protected.request(`${self.apiUrl.replace('v1', 'v3')}jobs/invite_to_apply`, 'PUT', params)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code === 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getBrandBasicInfo = cacheService.cache(function (brandId, includeLocations) {
        var deferred = $q.defer();

        var params = {
            include_locations: includeLocations
        };

       if(!brandId) {
           throw "No brand id";
       }

        _protected.request('brands/' + brandId + '/basic_info', 'GET', params)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code === 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    })[0];

    self.getEmploymentTypes = function (brandId) {
        var deferred = $q.defer();

       if(!brandId) {
           throw "No brand id";
       }

        _protected.request('/employment_types', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code === 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getBrandTroncSettings = function (brandId) {
        var deferred = $q.defer();

        if(!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/settings/troncs', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code === 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.updateBrandTroncSettings = function (brandId, payload) {
        var deferred = $q.defer();

        if(!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/settings/troncs', 'PUT', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code === 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getFairWorkweekCoveredEmployeesSettings = function (brandId) {
        var deferred = $q.defer();


        if(!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/fair_work_week/pay_types_settings', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code === 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.updateFairWorkweekCoveredEmployeesSettings = function (brandId, payload) {
        var deferred = $q.defer();


        if(!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/fair_work_week/pay_types_settings', 'PUT', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code === 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.saveJobEmploymentTypes = function (brandId, jobId, payload) {
        var deferred = $q.defer();

       if(!brandId) {
           throw "No brand id";
       }

       if(!jobId) {
           throw "No job id";
       }

        _protected.request('brands/' + brandId + '/jobs/' + jobId + '/employment_types', 'PUT', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code === 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getEmployers = function (brandId, params) {

        var deferred = $q.defer();

        params = params || {};

        var _params = {
            limit: params.limit || 10,
            params: params.offset || 0
        };

        if (params.search_term) {
            _params.search_term = params.search_term
        }

        _protected.request('brands/' + brandId + '/users/search', 'GET', params)
            .then(function (res) {

                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;

    };

    self.getManagers = async (brandId, body) => {
        if (!brandId) {
            throw 'brandId id is required';
        }

        try {
            const res = await _protected.request(`brands/${brandId}/employers/search`, 'POST', body);

            if (res?.status === 200 && res.data?.data) {
                return res.data.data;
            } else {
                throw res;
            }
        } catch (err) {
            throw err;
        }
    };

    self.getBrandEnterprisesAndChildes = function (brandId) {
        var deferred = $q.defer();
        if (!brandId) {
            throw "No brand id";
        }
        _protected.request('brands/' + brandId + '/locations', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code === 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });
        return deferred.promise;
    };

    self.getTenantJobsSettings = function (brandId) {
        var deferred = $q.defer();
        if (!brandId) {
            throw "No brand id";
        }
        _protected.request('brands/' + brandId + '/tenant_jobs/settings', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code === 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });
        return deferred.promise;
    };

    self.getBrandJobTitlesForEmployee = function (brandId) {
        var deferred = $q.defer();

        _protected.request("employees/brands/" + brandId + "/job_titles", "GET")
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code === 200) {
                    deferred.resolve(res.data.data.job_titles || []);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };

    self.getAllowedCompensations = (brandId, location_ids, postType) => {
        var deferred = $q.defer();

        var params = {
            location_ids: location_ids,
        }

        if (postType) {
            params['job_post_type'] = postType;
        }

        _protected.request("brands/" + brandId + "/allowed_compensations", "GET", params)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    };

    self.getJobWageMatrixRules = async (brandId, positionCode) => {
        let response = await _protected.request(`brands/${brandId}/positions/${positionCode}/wage_matrix_range`, 'GET');
        if (response.status !== 200) {
            throw (response.error);
        }
        return response.data.data;
    };

    self.getRestBetweenWorkingDaysSettings = function (brandId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw 'brandId is required'
        }

        _protected.request('brands/' + brandId + '/settings/right_to_rest_compliance', 'GET')
            .then(function (res) {
                if (res.status === 200 && res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.updateRestBetweenWorkingDaysSettings = function (brandId, payload) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings/right_to_rest_compliance', 'PUT', payload)
            .then(function (res) {

                if (res && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getBrandAccessibilityToolsSettings = function (brandId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw 'brandId is required'
        }

        _protected.request('brands/' + brandId + '/services/ACCESSIBILITY_TOOL/settings', 'GET')
            .then(function (res) {
                if (res.status === 200 && res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getBrandBasicMedia = cacheService.cache(function (brandId) {
        var deferred = $q.defer();

        _protected.request("brand/basic_media/" + brandId , "GET")
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    })[0];

    self.searchBrandTree = function (brandId, offset, limit, searchTerm, includeParents, includeArchived) {
        var deferred = $q.defer();

        var payload = {
            offset: offset,
            limit: limit,
            search_term: searchTerm,
            include_parents: !!includeParents,
            include_archived: !!includeArchived,
        };

        if (!brandId) {
            throw 'brandId is required'
        }

        _protected.request('brands/' + brandId + '/brands/search', 'POST', payload)
            .then(function (res) {
                if (res.status === 200 && res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });


        return deferred.promise;
    };

    self.getUserBrandsList = (
        limit, afterPaginationBrandId, searchTerm, loadLocations,
        loadMedia, includeArchived, includeIsFavourite, includeClosedBrands, subBrandTreeId, includeActiveJobCount) => {
        var deferred = $q.defer();

        var apiUrl = environmentsConfig.get('coreReaderAPIServers');
        var url = apiUrl + 'users/brand/search';

        var payload = {
            limit: limit || 200,
            include_archived: !!includeArchived,
            include_is_favourite: !!includeIsFavourite,
            include_active_job_count: !!includeActiveJobCount,
        };

        if (afterPaginationBrandId) {
            payload['after_pagination_brand_id'] = afterPaginationBrandId;
        }

        if (searchTerm) {
            payload['search_term'] = searchTerm;
        }

        if (loadLocations !== undefined) {
            payload['load_locations'] = loadLocations;
        }

        if (loadMedia !== undefined) {
            payload['load_media'] = loadMedia;
        }

        if (includeClosedBrands !== undefined) {
            payload['include_closed_brands'] = includeClosedBrands;
        }

        if (subBrandTreeId) {
            payload['sub_brand_tree_id'] = subBrandTreeId;
        }

        _protected.request(url, 'POST', payload).then(function (data) {

            if (data && data.data && data.data.data) {
                deferred.resolve(data.data.data);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getSalariedBrandScheduleSettings = async (brandId) => {
        let response = await _protected.request(`brands/${brandId}/settings/salaried/schedule`, 'GET');
        if (response.status !== 200) {
            throw (response.error);
        }
        return response.data.data;
    };

    self.updateSalariedBrandScheduleSettings = async (brandId, payload) => {
        let response = await _protected.request(`brands/${brandId}/settings/salaried/schedule`, 'PUT', payload);
        if (response.status !== 200) {
            throw (response.error);
        }
        return response.data.data;
    };

    self.getBrandJobs = function (brandId, canManage, includeChildren) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/jobs?can_manage=' + canManage + '&include_children=' + includeChildren, 'GET').then(function (data) {
            if (data && data.data && data.data.data && data.data.status_code == 200) {
                deferred.resolve(data.data.data);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.compareJobs = async (jobIds) => {
        try {
            const apiUrl = environmentsConfig.get('coreReaderAPIServers');
            const url = apiUrl + 'public/jobs/compare';

            const payload = {
                job_ids: jobIds
            };

            const data = await _protected.request(url, 'POST', payload);

            if (data && data.data && data.data.data) {
                return data.data.data;
            } else {
                throw new Error('Invalid response data');
            }
        } catch (error) {
            throw error;
        }
    };


    self.getSpreadOfHours = function (brandId) {

        if (!brandId) {
            throw 'brandId is required';
        }

        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings/spread_of_hours', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code === 200) {
                    deferred.resolve(res.data.data.spread_of_hours);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    }

    self.updateSpreadOfHours = function (brandId, payload) {

        if (!brandId) {
            throw 'brandId is required';
        }

        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/settings/spread_of_hours', 'PUT', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    }

    self.withdrawApplication = async (applicationId) => {
        if (!applicationId) {
            throw 'application id is required';
        }

        try {
            const res = await _protected.request(`applications/${applicationId}/withdraw`, 'POST');

            if (res.status === 200 && res.data && res.data.data) {
                return res.data.data;
            } else {
                throw res;
            }
        } catch (err) {
            throw err;
        }
    };

    self.getCareerStoryPageSettings = cacheService.cache(async (brandId) => {
        const response = await _protected.request(`brands/${brandId}/career_story_pages/settings`, 'GET');

        if (response?.data?.data && response.status === 200) {
            return response.data.data;
        }

        throw response;
    })[0];

    self.getManagerOnDutySettings = async (brandId) => {
        const res = await _protected.request(`brands/${brandId}/brand_manager_on_duty_settings`, 'GET');

        if (res.status !== 200) {
            throw (res.error);
        }
        return res.data.data;

    }

    self.putManagerOnDutySettings = async (brandId, brandManagerOnDutySettings) => {
        let payload = {};
        payload['brand_manager_on_duty_settings'] = brandManagerOnDutySettings
        const res = await _protected.request(`brands/${brandId}/brand_manager_on_duty_settings`, 'PUT', payload);

        if (res.status !== 200) {
            throw (res.error);
        }
        return res.data.data;
    }
});
